import { render, staticRenderFns } from "./DepositDetailDialog.vue?vue&type=template&id=585aab52&scoped=true"
import script from "./DepositDetailDialog.vue?vue&type=script&lang=js"
export * from "./DepositDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./DepositDetailDialog.vue?vue&type=style&index=0&id=585aab52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585aab52",
  null
  
)

export default component.exports